import type { SVGProps } from 'react';

const Knife = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.218 15.625L16.838 19.25L19.25 16.833L15.631 13.208M13.218 15.625L15.631 13.208M13.218 15.625L10.806 18.042L6.444 13.672C5.3596 12.5875 4.7504 11.1166 4.7504 9.583C4.7504 8.04935 5.3596 6.57851 6.444 5.494L7.187 4.75L15.631 13.208"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Knife;
